module.exports = __webpack_public_path__ + "static/media/Avatars_Male-19.5403e368.png";